














































































import { Component, Vue } from 'vue-property-decorator';
import $ from 'jquery';
import { SecurityConfig, LayoutConfig } from '@/installationConfig';

interface ISideNavigationRoute {
  title?: string;
  to?: string;
  allowedRoles?: string[];
  icon?: string;
  badge?: number;
  items?: ISideNavigationRoute[];
}

@Component({})
export default class Sidenavigation extends Vue {
  public LayoutConfig = LayoutConfig;

  toggleNavbar() {
    $('body').toggleClass('sidebar-toggled');
    $('.sidebar').toggleClass('toggled');
    if ($('.sidebar').hasClass('toggled')) {
      ($('.sidebar .collapse') as any).collapse('hide');
    }
  }

  removeClass(id: string) {
    $(`#${id}`).removeClass('show');
  }

  routeAllowed(route: ISideNavigationRoute): boolean {
    if (route.items) {
      for (let i = route.items.length - 1; i >= 0; i--) {
        if (!this.routeAllowed(route.items[i])) {
          route.items.splice(i, 1);
        }
      }
    }

    if (!route.allowedRoles || route.allowedRoles.length === 0) {
      return true;
    }

    for (const role of route.allowedRoles) {
      if (this.$auth.hasRole(role)) {
        return true;
      }
    }

    return false;
  }

  get routes(): ISideNavigationRoute[] {
    return [
      {},
      {
        to: '/',
        title: 'Dashboard',
        icon: 'fa-tachometer-alt',
        allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.qualityGuardOneSkinGroup!],
      },
      { to: '/projects', title: 'Projecten', icon: 'fa-puzzle-piece' },
      {
        to: '/quotations',
        title: 'Verkoop',
        icon: 'fa-euro-sign',
        allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.quotationRead!],
      },
      {
        to: '/followup',
        title: 'Controle',
        icon: 'fa-percent',
        allowedRoles: [
          SecurityConfig.administratorGroup!,
          SecurityConfig.administrationGroup!,
          SecurityConfig.qualityGuardGroup!,
          SecurityConfig.qualityGuardOneSkinGroup!,
          SecurityConfig.projectCoordinatorGroup!,
        ],
      },
      {
        to: '/projectstoprogressoverview',
        title: 'Boekhouding',
        icon: 'fa-book',
        allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.administrationGroup!, SecurityConfig.projectCoordinatorGroup!],
      },

      {
        to: '/orders',
        title: 'Aankoop',
        icon: 'fa-cart-arrow-down',
        allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.purchaseRead!],
      },
      {
        to: '/contacts',
        title: 'Contacten',
        icon: 'fa-users',
        allowedRoles: [SecurityConfig.administratorGroup!],
      },
      {
        to: '/machinery',
        title: 'Verhuur',
        icon: 'fa-snowplow',
        allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.machineryRead!],
      },
      {
        to: '/tasks',
        title: 'Taken',
        icon: 'fa-tasks',
        badge: this.$store.getters.numberOfTasks,
      },
      {
        to: '/actionpoints',
        title: 'Actiepunten',
        icon: 'fas fa-clipboard-check',
        allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.qualityGuardOneSkinGroup!],
        badge: this.$store.getters.numberOfActionPoints,
      },
      {
        to: '/agenda',
        title: 'Agenda',
        icon: 'fa-calendar',
        allowedRoles: [SecurityConfig.administratorGroup!],
      },
      {
        to: '/projectMeasuringStateOverview',
        title: 'Lopende projecten',
        icon: 'fa-calendar-check',
        allowedRoles: [SecurityConfig.administratorGroup!],
      },
      { title: 'Artikelen', allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.articleReadWrite!] },
      {
        to: '/articles',
        title: 'Codes',
        icon: 'fa-shopping-basket',
        allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.articleReadWrite!],
      },
      {
        to: '/articlecategories',
        title: 'Categorieën',
        icon: 'fa-th-list',
        allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.articleReadWrite!],
      },
      {
        to: '/rawmaterials',
        title: 'Grondstoffen',
        icon: 'fa-table',
        allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.articleReadWrite!],
      },
      {
        title: 'Varia',
        allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.articleReadWrite!, SecurityConfig.taskAdmin!],
      },
      {
        title: 'Instellingen',
        icon: 'fa-cog',
        items: [
          { to: '/settings', title: 'Instellingen', allowedRoles: [SecurityConfig.administratorGroup!] },
          {
            to: '/tasks/templates',
            title: 'Taak templates',
            allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.taskAdmin!],
          },
          {
            to: '/tasks/procedures',
            title: 'Taak procedures',
            allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.taskAdmin!],
          },
          {
            to: '/settings/quotationconditions',
            title: 'Offerte voorwaarden',
            allowedRoles: [SecurityConfig.administratorGroup!],
          },
          {
            to: '/settings/machineryprofiles',
            title: 'Machine profielen',
            allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.machineryReadWrite!],
          },
          {
            to: '/settings/machineryeventtypes',
            title: 'Machine events',
            allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.machineryReadWrite!],
          },
          {
            to: '/settings/machinerystatus',
            title: 'Machinestatus',
            allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.machineryReadWrite!],
          },
          { to: '/employees', title: 'Medewerkers', allowedRoles: [SecurityConfig.administratorGroup!] },
          {
            to: '/settings/catalogs',
            title: 'Lijsten',
            allowedRoles: [SecurityConfig.administratorGroup!],
          },
          {
            to: '/settings/counters',
            title: 'Tellers',
            allowedRoles: [SecurityConfig.administratorGroup!],
          },
          {
            to: '/settings/mailtemplates',
            title: 'Mail templates',
            allowedRoles: [SecurityConfig.administratorGroup!],
          },
          {
            to: '/settings/TunnelGroups',
            title: this.$t('objects.tunnelGroups.pluralCap')!.toString(),
            allowedRoles: [SecurityConfig.administratorGroup!],
          },
          { to: '/dashboards', title: 'Dashboards', allowedRoles: [SecurityConfig.administratorGroup!] },
        ],
        allowedRoles: [SecurityConfig.administratorGroup!, SecurityConfig.machineryReadWrite!, SecurityConfig.taskAdmin!],
      },
    ];
  }

  get inProduction(): boolean {
    return this.$store.getters.inProduction;
  }

  get allowedRoutes(): ISideNavigationRoute[] {
    const allowedRoutes = [...this.routes];

    for (let i = allowedRoutes.length - 1; i >= 0; i--) {
      if (!this.routeAllowed(allowedRoutes[i])) {
        allowedRoutes.splice(i, 1);
      }
    }

    return allowedRoutes;
  }

  get numberOfTasks(): number {
    return this.$store.getters.numberOfTasks;
  }
}
